export class SolicitacaoBase {
	codigoOrgao?: number;
	cpfSolicitante?: string;
	dataExpiracao?: string;
	dataHoraSolicitacao?: string;
	id?: number;
	nomeOrgao?: string;
	situacao?: string;
}
